import React, { Component } from "react";
import { Helmet } from "react-helmet";

import Header from "../components/HeaderSection/Header";
import HeroSection from "../components/HeroSection/HeroOne";
import Counter from "../components/CounterSection/Counter";
import FeatureSection from "../components/Features/FeatureOne";
import ServiceSection from "../components/ServiceSection/ServiceOne";
import DiscoverSection from "../components/DiscoverSection/DiscoverOne";
import Work from "../components/WorkSection/Work";
import ScreenshotSection from "../components/ScreenshotSection/ScreenshotsOne";
import ReviewSection from "../components/ReviewSection/ReviewOne";
import PricingSection from "../components/PricingSection/PricingOne";
import FaqSection from "../components/FaqSection/FaqOne";
import Download from "../components/DownloadSection/Download";
import Subscribe from "../components/SubscribeSection/Subscribe";
import Team from "../components/TeamSection/Team";
import ContactSection from "../components/ContactSection/Contact";
import FooterSection from "../components/FooterSection/Footer";
import PoliciesAndCodesSection from "../components/PoliciesAndCodes/PoliciesAndCodesOne";

class ThemeOne extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>MoneyMonk - Instant Personal Loans | RBI Registered NBFC</title>
          <meta name="description" content="MoneyMonk by Monk Capital Pvt Ltd offers quick digital personal loans for salaried and self-employed individuals. 100% online, minimal documentation. Download the app and apply in minutes." />
          <link rel="canonical" href="https://moneymonkapp.in/" />
          <script type="application/ld+json">{JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What is Money Monk, and why should I choose it over a traditional bank loan?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "MoneyMonk is an innovative digital product offered by Monk Capital Pvt Ltd, specializing in providing personal loans to both salaried and self-employed professionals. The main advantages over a traditional bank loan are speed and convenience. The entire process is completely digitally driven and can be completed online with minimal documentation, generally taking no more than 15 minutes. Upon approval, the money is typically received in your account instantly."
                }
              },
              {
                "@type": "Question",
                "name": "What are the key eligibility criteria for applying for a loan?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "To be eligible for a personal loan through LoanFront, applicants must be Indian Citizens over 21 years of age and have a stable monthly source of income of above ₹18,000 (with an annual household income greater than ₹3 Lakhs). You must be a salaried or self-employed individual. Crucially, for the application process, your Aadhaar must be linked with your PAN, and the mobile number used for registration must be linked with your Aadhaar card for e-signing the Loan Agreement."
                }
              },
              {
                "@type": "Question",
                "name": "What are the available loan amounts, interest rates, and repayment tenures?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "LoanFront offers loan amounts ranging from ₹25000 up to ₹2 Lakhs. The products include: Salary advance loans (ranging from ₹25000 to ₹200,000) and Short-term personal loans (ranging from ₹25,000 to ₹2 Lakhs). The loan tenure options range between 62 days to 180 days (equivalent to 2 to 6 EMIs). Interest rates start from 12% up to a maximum cap of 36% per annum, depending on the customer's risk profile."
                }
              },
              {
                "@type": "Question",
                "name": "What is the step-by-step process for applying for a loan using the app?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "The process is designed to be simple and user-friendly: 1. Download the MoneyMonk app from the Play Store. 2. Register using your Mobile Number or Gmail account. 3. Fill basic details to check your eligibility. 4. Perform Video KYC. 5. Choose your loan amount. 6. Provide bank account details for disbursement. 7. E-sign the loan agreement. 8. Receive the loan amount directly in your bank account."
                }
              },
              {
                "@type": "Question",
                "name": "Are there any fees or hidden charges associated with the loan?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "MoneyMonk emphasizes that all charges are transparent and communicated upfront via the Loan Sanction Letter, Loan Disbursal Letter, Loan Agreement, and GST invoices; there are no hidden charges. A standard processing fee is charged by all financial entities for operational efforts (like credit checks) and is deducted upfront from your loan amount. All the charges are disclosed during the sanction of the loan by way of Key Fact Statement as required by Reserve Bank of India."
                }
              },
              {
                "@type": "Question",
                "name": "What are the consequences of not paying the loan on time?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Timely repayment is extremely crucial. If you default on your payment: Late payment charges will be incurred, including a per-day penalty charge starting from the first day overdue. The rate of annualized penal charges is 36%, applied daily, calculated after a grace period of 2 days. Your Credit Score will be affected — delayed payments are reported to Credit Bureaus (CRIF / CIBIL / Experian). You will automatically become ineligible for quicker personal loans of a higher value from LoanFront in the future. For accounts where the EMI remains unpaid for more than 90 days, the account shall become a Non-Performing Asset (NPA)."
                }
              }
            ]
          })}</script>
        </Helmet>
        {/*====== Scroll To Top Area Start ======*/}
        <div id="scrollUp" title="Scroll To Top">
          <i className="fas fa-arrow-up" />
        </div>
        {/*====== Scroll To Top Area End ======*/}
        <div className="main">
          <Header imageData={"/img/logo-white.png"} />
          <HeroSection />
          <Counter />
          <FeatureSection />
          <ServiceSection />
          <DiscoverSection />
          <Work />
          <PoliciesAndCodesSection />
          <ScreenshotSection />
          {/* <ReviewSection /> */}
          {/* <PricingSection /> */}
          <FaqSection />
          {/* <Team /> */}
          <Download />
          {/* <Subscribe /> */}
          <ContactSection />
          <FooterSection />
        </div>
      </div>
    );
  }
}

export default ThemeOne;
